export default {
  title: "Клиенттер тізімі",
  allClients: "Барлық клиенттер",
  internalClients: "Ішкі",
  internalClient: "Ішкі",
  externalClients: "Сыртқы",
  externalClient: "Сыртқы",
  clientsType: "Клиент түрі",

  noEnitity: {
    label: "Бет қолжетімсіз",
    text: "Сіздің заңды тұлғаңыз модерацияда",
  },
  needBuyTariff: "Клиенттерді цифрлау үшін тариф сатып алу қажет",
  noTradingPoint: "Сізде әзірге сауда нүктелері жоқ",
  digitizeClients: "Клиенттерді цифрлаңыз, олар сіздің тізіміңізде көрсетіледі",

  table: {
    inviteDate: "Тіркелу күні",
    fullName: "Аты-жөні",
    phone: "Телефон нөмірі",
    receiptsCount: "Сатып алулар саны",
    receiptsSum: "Сатып алулар сомасы",
  },

  clientCard: {
    title: "Клиент туралы ақпарат",
    client: {
      title: "Клиент",
      fields: {
        fullName: "Аты-жөні",
        gender: "Жынысы",
        birthDate: "Туған күні",
        phone: "Телефон нөмірі",
        clientType: "Клиент түрі",
        inviteDate: "Тіркелу күні",
        regSource: "Тіркелу көзі",
        rcCard: "RC картасының нөмірі",
        note: "Ескертпе",
      },
      phoneHint:
        "Телефон нөмірі тек ақылы тарифтерде және байланыс деректерін беруге және маркетингтік ұсыныстар алуға келісім берген клиенттерде ғана көрсетіледі.",
    },
    statistic: {
      title: "Статистика",
      block: {
        avgReceiptsSum: "Орташа чек",
        receiptsCount: "Сатып алулар саны",
        receiptsSum: "Айналым",
        writeOffPointsSum: "Бонустармен төлем",
      },
      totalNumberOfVisit: "Жалпы бару саны",
      firstVisit: "Алғашқы бару",
      lastVisit: "Соңғы бару",
      visitedShops: "Барған орындар",
    },
    receipts: {
      title: "Чектер",
      emptyState: {
        title: "Чектер жоқ",
        description: "Олар мұнда клиент сатып алғаннан кейін <br> пайда болады",
      },
    },
    reviews: {
      title: "Пікірлер",
      noReviews: "Әзірге пікір жоқ",
      itsAppearHere:
        "Олар мұнда клиент <br> пікір қалдырған кезде пайда болады",
    },
  },
  pointsAwarded: "Бонустар есептелді",
  digitizingOnYourTariffNotAvailable:
    "Клиенттерді цифрлау сіздің тарифіңізде қолжетімсіз",
  digitizingIntoRC: "RC PAY арқылы <br> клиенттерді цифрлау",
  fastDigitizingIntoTg: "Telegram-бот арқылы <br> жедел цифрлау",
  abilityToUseLinkOrQRcode:
    "Жаңа пайдаланушыларды шақыру үшін сілтемені немесе QR-кодты пайдалану мүмкіндігі тариф сатып алынғаннан кейін қолжетімді болады.",
  inviteClients: "Клиенттерді шақыру",
  selectPointToGenerateQR:
    "Жаңа клиенттерді RC PAY-ге тіркеу үшін сілтеме мен&nbsp;QR-код жасауға сауда нүктесін таңдаңыз.",
  invitingtoLoyaltyProgram: "Адалдық бағдарламасына шақыру",
  downloadQR: "QR-кодты жүктеу",
  linkCopied: "Сілтеме көшірілді",
  share: "Бөлісу",
  joinToLoyaltyProgram: "Адалдық бағдарламасына қосыл!",
  receiveDiscountNotifies:
    "Жеңілдіктер мен эксклюзивті акциялар туралы хабарландыру ал. Әрбір сатып алу үшін сыйақы және бонустармен төлем 99.9%-ға дейін.",
  clientServiceAndAppRcPay:
    "rcpay.ru клиенттік сервисі мен RC PAY қосымшасы – тиімді және ыңғайлы шопингке сенің жолсерігің!",
};
